import type { ClientSummary, StAustinClient, StAustinConversation } from '@/types/client-management.types';

export const demoDates = {
  today: new Date().toISOString(),
  yesterday: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
  lastWeek: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
  lastMonth: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
};

export const demoClientSummaries: ClientSummary[] = [
  {
    id: 1,
    idCliente: 1,
    nombre: 'María',
    apellido: 'González',
    correoElectronico: 'maria.gonzalez@email.com',
    numeroTelefono: '+1234567890',
    leadStatus: 'Caliente',
    fechaUltimoMensaje: demoDates.today,
    citaAgendada: true,
    asesorRespondio: true,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 1
  },
  {
    id: 2,
    idCliente: 2,
    nombre: 'Carlos',
    apellido: 'Rodríguez',
    correoElectronico: 'carlos.rodriguez@email.com',
    numeroTelefono: '+1234567891',
    leadStatus: 'Tibio',
    fechaUltimoMensaje: demoDates.yesterday,
    citaAgendada: false,
    asesorRespondio: true,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 0
  },
  {
    id: 3,
    idCliente: 3,
    nombre: 'Ana',
    apellido: 'Martínez',
    correoElectronico: 'ana.martinez@email.com',
    numeroTelefono: '+1234567892',
    leadStatus: 'Caliente',
    fechaUltimoMensaje: demoDates.lastWeek,
    citaAgendada: true,
    asesorRespondio: false,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 1
  },
  {
    id: 4,
    idCliente: 4,
    nombre: 'Luis',
    apellido: 'Pérez',
    correoElectronico: 'luis.perez@email.com',
    numeroTelefono: '+1234567893',
    leadStatus: 'Caliente',
    fechaUltimoMensaje: demoDates.today,
    citaAgendada: true,
    asesorRespondio: true,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 1
  },
  {
    id: 5,
    idCliente: 5,
    nombre: 'Carmen',
    apellido: 'López',
    correoElectronico: 'carmen.lopez@email.com',
    numeroTelefono: '+1234567894',
    leadStatus: 'Frio',
    fechaUltimoMensaje: demoDates.lastMonth,
    citaAgendada: false,
    asesorRespondio: true,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 3
  },
  {
    id: 6,
    idCliente: 6,
    nombre: 'Roberto',
    apellido: 'Sánchez',
    correoElectronico: 'roberto.sanchez@email.com',
    numeroTelefono: '+1234567895',
    leadStatus: undefined,
    fechaUltimoMensaje: demoDates.yesterday,
    citaAgendada: false,
    asesorRespondio: false,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 0
  },
  {
    id: 7,
    idCliente: 7,
    nombre: 'Isabel',
    apellido: 'Ramírez',
    correoElectronico: 'isabel.ramirez@email.com',
    numeroTelefono: '+1234567896',
    leadStatus: 'Tibio',
    fechaUltimoMensaje: demoDates.lastWeek,
    citaAgendada: true,
    asesorRespondio: true,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 1
  },
  {
    id: 8,
    idCliente: 8,
    nombre: 'Fernando',
    apellido: 'Torres',
    correoElectronico: 'fernando.torres@email.com',
    numeroTelefono: '+1234567897',
    leadStatus: undefined,
    fechaUltimoMensaje: demoDates.today,
    citaAgendada: false,
    asesorRespondio: true,
    fechaDeCreacion: demoDates.lastMonth,
    idEstado: 0
  }
];

export const demoClientDetails: Record<number, StAustinClient> = {
  1: {
    idCliente: 1,
    fechaDeCreacion: demoDates.lastMonth,
    idUbicacionInteres: 1,
    nombre: 'María',
    apellido: 'González',
    numeroTelefono: '+1234567890',
    correoElectronico: 'maria.gonzalez@email.com',
    esperandoRespuesta: 0,
    fechaUltimoMensaje: demoDates.today,
    citaAgendada: true,
    asesorRespondio: true,
    presupuesto: '$500,000 - $750,000',
    profesion: 'Ingeniera de Software',
    idEspecialidadPropiedad: 1,
    idInstrumentoInversion: 1,
    idEstado: 1,
    existeEnHubSpot: true,
    correoAsesor: 'juan.asesor@staustin.com',
    fechaAsignacionAsesor: demoDates.lastWeek,
    briefCompartido: true,
    leadStatus: 'Caliente',
    modalidadCita: 'Presencial',
    fechaCita: '2024-01-15 10:00:00',
    idCita: 'CITA-001'
  },
  2: {
    idCliente: 2,
    fechaDeCreacion: demoDates.lastMonth,
    idUbicacionInteres: 2,
    nombre: 'Carlos',
    apellido: 'Rodríguez',
    numeroTelefono: '+1234567891',
    correoElectronico: 'carlos.rodriguez@email.com',
    esperandoRespuesta: 1,
    fechaUltimoMensaje: demoDates.yesterday,
    citaAgendada: false,
    asesorRespondio: true,
    presupuesto: '$300,000 - $500,000',
    profesion: 'Médico',
    idEspecialidadPropiedad: 2,
    idInstrumentoInversion: 2,
    idEstado: 2,
    existeEnHubSpot: true,
    correoAsesor: 'maria.asesora@staustin.com',
    fechaAsignacionAsesor: demoDates.lastWeek,
    briefCompartido: false,
    leadStatus: 'Tibio',
    modalidadCita: undefined,
    fechaCita: undefined,
    idCita: undefined
  }
};

export const demoConversations: Record<number, StAustinConversation[]> = {
  1: [
    {
      idHistorialConversacion: 1,
      idCliente: 1,
      mensaje: { text: 'Hola, estoy interesada en conocer más sobre las propiedades disponibles en la zona norte.' },
      fechaDeEnvio: demoDates.lastMonth,
      remitente: 'user'
    },
    {
      idHistorialConversacion: 2,
      idCliente: 1,
      mensaje: { text: '¡Perfecto! Te puedo ayudar con información sobre nuestras propiedades. ¿Tienes algún presupuesto en mente?' },
      fechaDeEnvio: demoDates.lastMonth,
      remitente: 'bot'
    },
    {
      idHistorialConversacion: 3,
      idCliente: 1,
      mensaje: { text: 'Estoy buscando algo entre $500,000 y $750,000. Trabajo en tecnología y me gustaría algo cerca de oficinas.' },
      fechaDeEnvio: demoDates.lastMonth,
      remitente: 'user'
    },
    {
      idHistorialConversacion: 4,
      idCliente: 1,
      mensaje: { text: 'Excelente, tengo varias opciones que podrían interesarte. Te voy a conectar con un asesor especializado.' },
      fechaDeEnvio: demoDates.lastMonth,
      remitente: 'bot'
    },
    {
      idHistorialConversacion: 5,
      idCliente: 1,
      mensaje: { text: 'Hola María, soy Juan, tu asesor asignado. He revisado tu perfil y tengo propiedades perfectas para ti. ¿Podemos agendar una cita?' },
      fechaDeEnvio: demoDates.lastWeek,
      remitente: 'asesor'
    },
    {
      idHistorialConversacion: 6,
      idCliente: 1,
      mensaje: { text: 'Perfecto, me gustaría ver las propiedades. ¿Qué días tienes disponibles?' },
      fechaDeEnvio: demoDates.lastWeek,
      remitente: 'user'
    },
    {
      idHistorialConversacion: 7,
      idCliente: 1,
      mensaje: { text: 'Tengo disponibilidad el lunes 15 de enero a las 10:00 AM. ¿Te funciona?' },
      fechaDeEnvio: demoDates.yesterday,
      remitente: 'asesor'
    },
    {
      idHistorialConversacion: 8,
      idCliente: 1,
      mensaje: { text: 'Perfecto, nos vemos el lunes. ¿Me puedes enviar la dirección?' },
      fechaDeEnvio: demoDates.today,
      remitente: 'user'
    }
  ],
  2: [
    {
      idHistorialConversacion: 9,
      idCliente: 2,
      mensaje: { text: 'Buenos días, estoy buscando una propiedad para consulta médica.' },
      fechaDeEnvio: demoDates.lastWeek,
      remitente: 'user'
    },
    {
      idHistorialConversacion: 10,
      idCliente: 2,
      mensaje: { text: 'Hola Carlos, te puedo ayudar con propiedades para uso médico. ¿Qué tipo de consulta manejas?' },
      fechaDeEnvio: demoDates.lastWeek,
      remitente: 'bot'
    },
    {
      idHistorialConversacion: 11,
      idCliente: 2,
      mensaje: { text: 'Soy cardiólogo y necesito espacio para consulta y algunos equipos especializados.' },
      fechaDeEnvio: demoDates.lastWeek,
      remitente: 'user'
    },
    {
      idHistorialConversacion: 12,
      idCliente: 2,
      mensaje: { text: 'Perfecto, te voy a conectar con María, nuestra especialista en propiedades médicas.' },
      fechaDeEnvio: demoDates.lastWeek,
      remitente: 'bot'
    },
    {
      idHistorialConversacion: 13,
      idCliente: 2,
      mensaje: { text: 'Hola Carlos, soy María. Tengo varias opciones ideales para consultas médicas. ¿Cuál es tu presupuesto?' },
      fechaDeEnvio: demoDates.yesterday,
      remitente: 'asesor'
    },
    {
      idHistorialConversacion: 14,
      idCliente: 2,
      mensaje: { text: 'Estoy considerando entre $300,000 y $500,000.' },
      fechaDeEnvio: demoDates.yesterday,
      remitente: 'user'
    }
  ]
};

export const demoStats = {
  totalClients: 8,
  citasAgendadas: 3,
  asesorRespondieron: 6,
  leadStatusCounts: {
    qualified: 2,
    contacted: 2,
    interested: 2,
    appointment_scheduled: 1,
    not_interested: 1
  },
  conversionRate: '37.5'
};